import { ToolbarItem, UtilityButton } from '@kinesis/bungle';
import { Link } from 'react-router-dom';
import { StyledBreadcrumbText } from './breadcrumbs.styles';

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { currentNav, currentNavLink } = props;

  return (
    <ToolbarItem>
      <UtilityButton magnitude={'medium'} as={Link} to={currentNavLink}>
        <StyledBreadcrumbText>{currentNav}</StyledBreadcrumbText>
      </UtilityButton>
    </ToolbarItem>
  );
};

export type BreadcrumbsProps = {
  currentNav?: string;
  currentNavLink?: string;
};

export { Breadcrumbs };
